import { BaseLead } from '../Models/Lead';
import ApiService from './ApiService';

export async function assignLeads(leadIds: number[], userId: string): Promise<BaseLead[]> {
  const response = await ApiService.assignLeads<BaseLead[]>(leadIds, userId);
  return response.data;
}
